// TO-DO: it would be nice to rename to DEFAULT_DOUBLE_CURRENCY_DELIMITER (breaking change)
export var defaultDoubleCurrencyDelimiter = ' / ';
export var NON_BREAKING_SPACE_CHARACTER = ' ';
export var SEPARATORS = /*#__PURE__*/function (SEPARATORS) {
  SEPARATORS["COMMA"] = ",";
  SEPARATORS["DOT"] = ".";
  return SEPARATORS;
}({});